import styles from "./tripsSection.css";

import Section from "../section";
import TripThumbnail from "./tripThumbnail";
import trips from "../../../data/trips.json";

function TripsSection() {
  return (
    <Section title="WYCIECZKI">
      <div className="trips-section">
        {trips.map((trip, index) => (
          <TripThumbnail trip={trip} type="excursion" key={index} />
        ))}
      </div>
    </Section>
  );
}

export default TripsSection;
